export const CONTENT_WIDTH = 980
export const MOBILE_CONTENT_WIDTH = '85%'
